<template>
  <div class="payment-methods-container">
    <slot name="gPay" />
    <slot name="applePay" />
    <div class="credit-card-container">
      <slot name="creditCard" />
    </div>
    <slot name="paypal" />
  </div>
</template>

<script setup lang="ts">
defineEmits(['select-payment-method']);
</script>

<style scoped lang="scss">
.payment-methods-container {
  width: 100%;
  will-change: contents;

  .credit-card-container {
    width: 100%;
  }
}
</style>
